import { Logo } from '@/components/brand/Logo'
import { cn } from '@/lib/utils'
import { ProductTab, PROTOTYPE_TABS, TAB_LABEL } from './prototypeNav'
import { SignedInAvatar } from './SignedInAvatar'

interface TopProductNavProps {
  tab: ProductTab
  onSelect: (tab: ProductTab) => void
  orgName: string
  /** The row showing in the main area, or null for the dashboard. */
  page: string | null
  onNavigate: (page: string | null) => void
}

const LINK_CLASS = '-mb-px border-b-2 px-2 py-3 text-xs'
const ACTIVE_CLASS = 'border-brand-700 text-ink font-semibold'
const IDLE_CLASS = 'text-ink-500 hover:text-ink border-transparent'

/** The products as a top bar — the side nav's job moved up and across. */
export function TopProductNav({ tab, onSelect, orgName, page, onNavigate }: TopProductNavProps) {
  return (
    // Three tracks, so the products stay centred on the bar whatever flanks them.
    <div className="border-ink-100 grid grid-cols-[1fr_auto_1fr] items-center gap-4 border-b bg-white px-4">
      <div className="flex min-w-0 items-center gap-3">
        <Logo size="small" width={44} />
        {/* The Dashboard row is gone under this placement, so the carrier name carries it. */}
        <button
          type="button"
          onClick={() => onNavigate(null)}
          aria-current={page === null ? 'page' : undefined}
          className={cn(LINK_CLASS, 'truncate capitalize', page === null ? ACTIVE_CLASS : IDLE_CLASS)}
        >
          {orgName}
        </button>
      </div>

      <div className="flex items-center gap-1">
        {PROTOTYPE_TABS.map((entry) => {
          // On the dashboard no product is open, so none of them is the page you are on.
          const active = page !== null && entry === tab
          return (
            <button
              key={entry}
              type="button"
              onClick={() => onSelect(entry)}
              aria-current={active ? 'page' : undefined}
              className={cn(LINK_CLASS, active ? ACTIVE_CLASS : IDLE_CLASS)}
            >
              {TAB_LABEL[entry]}
            </button>
          )
        })}
      </div>

      <div className="flex justify-end">
        <SignedInAvatar />
      </div>
    </div>
  )
}
